/**
 * Service for the signup-without-payment API only.
 * Does not modify existing auth.service.
 * Authorization header is added by api.utils when user is logged in (e.g. add-on workspace).
 */
import { API_ENDPOINTS } from '../constants/endpoints';
import { post } from '../utils/api.utils';
import type {
  SignupWithoutPaymentRequest,
  SignupWithoutPaymentResponse,
} from '../types/signupWithoutPayment';

export async function signupWithoutPayment(
  payload: SignupWithoutPaymentRequest
): Promise<SignupWithoutPaymentResponse> {
  try {
    const response = await post<SignupWithoutPaymentResponse | { data: SignupWithoutPaymentResponse }>(
      API_ENDPOINTS.AUTH.SIGNUP_WITHOUT_PAYMENT,
      payload
    );
    const data = (response as any)?.data ?? response;
    return data as SignupWithoutPaymentResponse;
  } catch (error: any) {
    const status = error.response?.status;
    const body = error.response?.data;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : body?.error || undefined;

    if (status === 400) {
      throw new Error(message || 'Invalid or missing fields. Please check your input.');
    }
    if (status === 401) {
      throw new Error(message || 'Email already registered.');
    }
    if (status === 409) {
      throw new Error(message || 'Account already exists.');
    }
    if (status >= 500) {
      throw new Error(message || 'Server error. Please try again later.');
    }
    throw new Error(message || 'Signup failed. Please try again.');
  }
}
